import { useAuthStateStore } from '../../store';
export const getUUID = (publicIfNull) => {
    if (useAuthStateStore?.getState) {
        return useAuthStateStore.getState().getUUID(publicIfNull);
    }
    if (publicIfNull)
        return 'public';
    return undefined;
};
//# sourceMappingURL=getUUID.js.map